export const GET_FORM_BS_ACTIVITY_REQUEST = "GET_FORM_BS_ACTIVITY_REQUEST";
export const GET_FORM_BS_ACTIVITY_SUCCESS = "GET_FORM_BS_ACTIVITY_SUCCESS";
export const GET_FORM_BS_ACTIVITY_FAILURE = "GET_FORM_BS_ACTIVITY_FAILURE";
